import styled from 'styled-components';

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;

  @media screen and (max-width: 640px) {
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

export const BannerMessageGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;

  @media screen and (max-width: 640px) {
    width: 100%;
  }
`;

export const BannerTextContainer = styled.span`
  min-width: 0;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
`;

export const BannerActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  min-width: fit-content;

  @media screen and (max-width: 640px) {
    width: 100%;
    justify-content: space-between;
  }
`;
